import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/markyctian/nes-design/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Radio, RadioGroup, Table } from '@components';
import { Props } from './config';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const TagVersion = makeShortcode("TagVersion");
const Explain = makeShortcode("Explain");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "radio"
    }}>{`Radio`}</h2>
    <TagVersion component="Radio" mdxType="TagVersion" />
    <h2 {...{
      "id": "use-and-import"
    }}>{`Use and Import`}</h2>
    <Explain component="Radio" isCopyable mdxType="Explain" />
    <h2 {...{
      "id": "case"
    }}>{`Case`}</h2>
    <Playground __position={2} __code={'() => {\n  const [checked, setChecked] = useState(false)\n  return (\n    <Radio checked={checked} onFocus={e => setChecked(!checked)}>\n      {\' \'}\n      Sure{\' \'}\n    </Radio>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Radio,
      RadioGroup,
      Table,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Radio" mdxType="Playground">
  {() => {
        const [checked, setChecked] = useState(false);
        return <Radio checked={checked} onFocus={e => setChecked(!checked)} mdxType="Radio"> Sure </Radio>;
      }}
    </Playground>
    <Playground __position={3} __code={'() => {\n  const [value, setValue] = useState(\'yes\')\n  return (\n    <div>\n      <div\n        style={{\n          display: \'flex\',\n          height: 50,\n          fontSize: 18,\n          fontWeight: \'bold\',\n          alignItems: \'center\',\n        }}\n      >\n        Play Game\n      </div>\n      <RadioGroup\n        twinkleDelay={true}\n        value={value}\n        onChange={value => setValue(value)}\n        options={[\n          { label: \'Yes\', value: \'yes\', defaultChecked: true },\n          { label: \'No\', value: \'no\' },\n        ]}\n      />\n      <RadioGroup\n        theme=\"dark\"\n        value={value}\n        style={{\n          display: \'flex\',\n          background: \'black\',\n          height: 50,\n          alignItems: \'center\',\n        }}\n        defaultValue=\"yes\"\n        onChange={value => setValue(value)}\n        options={[\n          { label: \'Yes\', value: \'yes\', defaultChecked: true },\n          { label: \'No\', value: \'no\' },\n        ]}\n      />\n    </div>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Radio,
      RadioGroup,
      Table,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="RadioGroup" mdxType="Playground">
  {() => {
        const [value, setValue] = useState('yes');
        return <div>
      <div style={{
            display: 'flex',
            height: 50,
            fontSize: 18,
            fontWeight: 'bold',
            alignItems: 'center'
          }}>
        Play Game
      </div>
      <RadioGroup twinkleDelay={true} value={value} onChange={value => setValue(value)} options={[{
            label: 'Yes',
            value: 'yes',
            defaultChecked: true
          }, {
            label: 'No',
            value: 'no'
          }]} mdxType="RadioGroup" />
      <RadioGroup theme="dark" value={value} style={{
            display: 'flex',
            background: 'black',
            height: 50,
            alignItems: 'center'
          }} defaultValue="yes" onChange={value => setValue(value)} options={[{
            label: 'Yes',
            value: 'yes',
            defaultChecked: true
          }, {
            label: 'No',
            value: 'no'
          }]} mdxType="RadioGroup" />
    </div>;
      }}
    </Playground>
    <Playground __position={4} __code={'() => {\n  const [value, setValue] = useState(\'orange\')\n  return (\n    <div>\n      <div\n        style={{\n          display: \'flex\',\n          height: 50,\n          fontSize: 18,\n          fontWeight: \'bold\',\n          alignItems: \'center\',\n        }}\n      >\n        Choose Fruit\n      </div>\n      <RadioGroup\n        twinkleDelay={1000}\n        value={value}\n        onChange={value => setValue(value)}\n        options={[\n          { label: \'Apple\', value: \'apple\', defaultChecked: true },\n          { label: \'Banana\', value: \'banana\' },\n        ]}\n      >\n        <Radio\n          labelProps={{ style: { display: \'block\' } }}\n          value=\"orange\"\n          children=\"Orange\"\n        />\n      </RadioGroup>\n    </div>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Radio,
      RadioGroup,
      Table,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="RadioGroup + Radio" mdxType="Playground">
  {() => {
        const [value, setValue] = useState('orange');
        return <div>
        <div style={{
            display: 'flex',
            height: 50,
            fontSize: 18,
            fontWeight: 'bold',
            alignItems: 'center'
          }}>
          Choose Fruit
        </div>
          <RadioGroup twinkleDelay={1000} value={value} onChange={value => setValue(value)} options={[{
            label: 'Apple',
            value: 'apple',
            defaultChecked: true
          }, {
            label: 'Banana',
            value: 'banana'
          }]} mdxType="RadioGroup">
            <Radio labelProps={{
              style: {
                display: 'block'
              }
            }} value="orange" children="Orange" mdxType="Radio" />
          </RadioGroup>
      </div>;
      }}
    </Playground>
    <Playground __position={5} __code={'<RadioGroup\n  disabled\n  twinkleDelay={false}\n  defaultValue=\"yes\"\n  options={[\n    { label: \'Yes\', value: \'yes\', defaultChecked: true },\n    { label: \'No\', value: \'no\' },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Radio,
      RadioGroup,
      Table,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="disabled" mdxType="Playground">
  <RadioGroup disabled twinkleDelay={false} defaultValue="yes" options={[{
        label: 'Yes',
        value: 'yes',
        defaultChecked: true
      }, {
        label: 'No',
        value: 'no'
      }]} mdxType="RadioGroup" />
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <>
  {[Props.public, Props.radioGroup, Props.radio, Props.option].map(({
        columns,
        data,
        footer
      }) => <div style={{
        marginTop: 20
      }}>
        <Table theme="dark" columns={columns} data={data} footer={() => <div style={{
          height: 60,
          borderTop: '4px solid white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
              {footer}
            </div>} mdxType="Table" />
      </div>)}
    </>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      